export class TagChangeDetector {
    static Mode = Object.freeze({
        NEW:    'new',
        DELETE: 'delete',
        UPDATE: 'update',
    });

    static compare(storedTag, newTag) {
        if (storedTag == null && newTag == null) return null;

        if (
            storedTag == null ||
            storedTag.height == undefined ||
            storedTag.left == undefined ||
            storedTag.top == undefined ||
            storedTag.width == undefined
        ) {
            return TagChangeDetector.Mode.NEW;
        }

        if (newTag == null) {
            return storedTag.text == null ? null : TagChangeDetector.Mode.DELETE;
        }

        const newText = newTag.text != null
            ? TagChangeDetector.#normalizeText(newTag.text)
            : newTag.text;

        if (
            (storedTag.height == newTag.height &&
             storedTag.left == newTag.left &&
             storedTag.top == newTag.top &&
             storedTag.width == newTag.width &&
             storedTag.level == newTag.level &&
             storedTag.text == newText &&
             TagChangeDetector.#serializeMetadata(storedTag.metadata) === TagChangeDetector.#serializeMetadata(newTag.metadata)) ||
            storedTag.text == undefined
        ) {
            return null;
        }

        return TagChangeDetector.Mode.UPDATE;
    }

    static #normalizeText(text) {
        return text.replace(/\s/g, ' ').trim().replace(/\s+/g, ' ');
    }

    static #serializeMetadata(m) {
        if (m == null) return null;
        return JSON.stringify(Object.fromEntries(Object.entries(m).sort(([a], [b]) => a.localeCompare(b))));
    }
}
